Vue.component('companylist', {
    template:'#companylist-template',

    data:function(){
        return{
            list: [],
            searchString:''
        };
    },
    created:function(){

        activeInstance = this;
        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/company/list/all',function(response){
            $('body').LoadingOverlay("hide");
            activeInstance.list=response;
        }).bind(this);
    },

    methods:{
        create:function(){
            bootbox.prompt('Az új cégneve:',function(value){
                showLoadingOverlay();
                Vue.http.post(baseURL+'/admin/company/create',{name:value}).then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.list.push(response.data);
                });
            });
        },
        edit:function(company){
            location.href = baseURL+'/admin/company/edit/'+company.id;
        },
        destroy:function(company){


            bootbox.confirm('Biztosan el akarod távolítani ezt a céget?', function(value){
                if(value!=null){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/company/destroy',{company:company}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A felhasználó törölve.');
                    });
                }
            });


        }

    }

}); 